/* tslint:disable */
/* eslint-disable */
/**
 * BROStar API
 * Simplify the data management of the BRO
 *
 * The version of the OpenAPI document: v1
 * Contact: servicedesk@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { FieldMeasurement } from "./FieldMeasurement";
import {
  FieldMeasurementFromJSON,
  FieldMeasurementFromJSONTyped,
  FieldMeasurementToJSON,
  FieldMeasurementToJSONTyped,
} from "./FieldMeasurement";

/**
 *
 * @export
 * @interface ApiGarFieldmeasurementsList200Response
 */
export interface ApiGarFieldmeasurementsList200Response {
  /**
   *
   * @type {number}
   * @memberof ApiGarFieldmeasurementsList200Response
   */
  count: number;
  /**
   *
   * @type {string}
   * @memberof ApiGarFieldmeasurementsList200Response
   */
  next?: string | null;
  /**
   *
   * @type {string}
   * @memberof ApiGarFieldmeasurementsList200Response
   */
  previous?: string | null;
  /**
   *
   * @type {Array<FieldMeasurement>}
   * @memberof ApiGarFieldmeasurementsList200Response
   */
  results: Array<FieldMeasurement>;
}

/**
 * Check if a given object implements the ApiGarFieldmeasurementsList200Response interface.
 */
export function instanceOfApiGarFieldmeasurementsList200Response(
  value: object
): value is ApiGarFieldmeasurementsList200Response {
  if (!("count" in value) || value["count"] === undefined) return false;
  if (!("results" in value) || value["results"] === undefined) return false;
  return true;
}

export function ApiGarFieldmeasurementsList200ResponseFromJSON(
  json: any
): ApiGarFieldmeasurementsList200Response {
  return ApiGarFieldmeasurementsList200ResponseFromJSONTyped(json, false);
}

export function ApiGarFieldmeasurementsList200ResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ApiGarFieldmeasurementsList200Response {
  if (json == null) {
    return json;
  }
  return {
    count: json["count"],
    next: json["next"] === undefined ? undefined : json["next"] === null ? null : json["next"],
    previous:
      json["previous"] === undefined
        ? undefined
        : json["previous"] === null
        ? null
        : json["previous"],
    results: (json["results"] as Array<any>).map(FieldMeasurementFromJSON),
  };
}

export function ApiGarFieldmeasurementsList200ResponseToJSON(
  json: any
): ApiGarFieldmeasurementsList200Response {
  return ApiGarFieldmeasurementsList200ResponseToJSONTyped(json, false);
}

export function ApiGarFieldmeasurementsList200ResponseToJSONTyped(
  value?: ApiGarFieldmeasurementsList200Response | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    count: value["count"],
    next: value["next"],
    previous: value["previous"],
    results: (value["results"] as Array<any>).map(FieldMeasurementToJSON),
  };
}
